export default "__VITE_ASSET__CEWnd1nU__"